<template>
    <div class="right_box_main">
        <div class="card-box">
            <el-card :body-style="{ padding: '12px' }">
                <el-form :inline="true" :model="searchlist" size="mini">
                    <el-form-item label="组织机构:" style="margin: 0">
                        <el-input
                            placeholder="组织机构名称过滤"
                            v-model="filterText"
                        >
                        </el-input>
                    </el-form-item>
                    <el-form-item style="margin: 0">
                        <el-button type="primary" icon="el-icon-search"
                            >查询</el-button
                        >
                    </el-form-item>
                    <!-- 角色名查询 -->
                    <el-form-item style="float: right; margin: 0">
                        <el-button
                            type="primary"
                            icon="el-icon-search"
                            @click="searchlistdata('')"
                            >查询</el-button
                        >
                    </el-form-item>
                    <el-form-item
                        label="角色名称:"
                        style="float: right; margin: 0"
                    >
                        <el-input
                            placeholder="角色名称过滤"
                            v-model="searchlist.name"
                        >
                        </el-input>
                    </el-form-item>
                </el-form>
                <div class="table_card" style="margin-top: 6px">
                    <el-table
                        size="middle"
                        ref="myTable"
                        :header-cell-style="{ background: '#f8fafa' }"
                        align="center"
                        height="45"
                    >
                        <el-table-column
                            align="center"
                            label="组织机构列表"
                        ></el-table-column>
                        <el-table-column
                            :render-header="renderHeader"
                            width="130px"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            label="角色列表"
                            width="555px"
                        ></el-table-column>
                    </el-table>
                    <!-- 组织结构列表 -->
                    <el-tree
                        ref="tree"
                        class="filter-tree"
                        :data="treedata"
                        :props="defaultProps"
                        node-key="id"
                        :filter-node-method="filterNode"
                        default-expand-all
                        :expand-on-click-node="false"
                        :render-content="renderContent"
                    ></el-tree>
                    <!-- 角色列表 -->
                    <el-table
                        ref="multipleTable"
                        :data="tableData"
                        class="roleTable"
                        border
                        align="center"
                        current-row-key
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column
                            type="selection"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="name"
                            label="角色名称"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="useable"
                            label="状态"
                        >
                            <template slot-scope="scope">
                                <span
                                    v-if="scope.row.useable == 1"
                                    style="color: #0f7ef1"
                                    >启用</span
                                >
                                <span
                                    v-if="scope.row.useable == 0"
                                    style="color: #cd2b20"
                                    >禁用</span
                                >
                            </template>
                        </el-table-column>
                        <!-- <el-table-column align="center" label="分配子权限" width="200" fixed="right">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="light" content="子权限分配" placement="top-start">
                  <button class="tabBtn tabBtn-audit" style="font-size:12px;" @click="showDialogForm(scope.row.id,'assign')">子权限分配</button>
                </el-tooltip>
              </template>
            </el-table-column> -->
                    </el-table>
                </div>
            </el-card>
        </div>
        <el-dialog
            title="子权限分配"
            :visible.sync="showViewRight"
            width="700px"
            style="height: 600px"
        >
            <ViewRoleRight
                ref="viewRoleRight"
                :rowid="curOrgId"
                :roleId="roleId"
                @func="dialogReturn"
            ></ViewRoleRight>
        </el-dialog>
    </div>
</template>

<script>
import "@/assets/css/system.css"
import request from "../../../utils/request.js"
import ViewRoleRight from "../dialog/roleRightsDialog.vue"
export default {
    components: {
        ViewRoleRight,
    },
    data() {
        return {
            searchlist: {},
            filterText: "",
            treedata: [],
            defaultProps: {
                children: "children",
                label: "label",
            },
            orgTypes: [
                { value: "2", label: "街道", disabled: true },
                { value: "3", label: "社区", disabled: true },
                { value: "4", label: "网格", disabled: true },
            ],
            tableData: [],
            multipleSelection: [],
            clearSelection: "",
            toggleRowSelection: "",
            curOrgId: "", //当前选择组织id
            showViewRight: false,
            roleId: "", //继承角色id
        }
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val)
        },
    },
    methods: {
        //table头部内容自定义
        renderHeader(h) {
            return (
                <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-check"
                    on-click={() => this.saveData()}
                >
                    保存角色分配{" "}
                </el-button>
            )
        },
        //树形列表
        filterNode(value, data) {
            if (!value) return true
            return data.label.indexOf(value) !== -1
        },
        //树形结果显示内容自定义
        renderContent(h, { node, data, store }) {
            return (
                <span class="tree-span">
                    <span class="tree-span-label">
                        <el-radio
                            label={data.id}
                            v-model={this.curOrgId}
                            on-change={() => this.getOrgDatas()}
                        >
                            <el-tag type={data.css} size="small">
                                {data.tag}
                            </el-tag>
                            &nbsp;&nbsp;
                            {node.label}
                        </el-radio>
                    </span>
                </span>
            )
        },
        async getTreeDatas() {
            var res = await request({
                url: "/rbac/admin/org/info/OrgTreelist",
                method: "POST",
                data: {isValid: 1,},
            })
            if (res.content.length > 0) {
                res.content.forEach((item) => {
                    var children = []
                    if (item.children != null && item.children.length > 0) {
                        children = this.formateTree(item.children)
                    }
                    //1.机构 2.部门 3.岗位 4.人员
                    var tag = "机构"
                    var css = ""
                    if (item.orgLevel == "2") {
                        tag = "街道"
                        css = "success"
                    } else if (item.orgLevel == "3") {
                        tag = "社区"
                        css = "danger"
                    } else if (item.orgLevel == "4") {
                        tag = "网格"
                        css = ""
                    }
                    this.treedata.push({
                        id: item.orgId,
                        tag: tag,
                        css: css,
                        value: item.orgId,
                        label: item.label,
                        children: children,
                    })
                })
            }
        },
        formateTree(arr) {
            var temp = []
            if (arr.length > 0) {
                arr.forEach((item) => {
                    var children = []
                    if (item.children != null && item.children.length > 0) {
                        children = this.formateTree(item.children)
                    }
                    //1.机构 2.部门 3.岗位 4.人员
                    var tag = "机构"
                    var css = ""
                    if (item.orgLevel == "2") {
                        tag = "街道"
                        css = "success"
                    } else if (item.orgLevel == "3") {
                        tag = "社区"
                        css = "danger"
                    } else if (item.orgLevel == "4") {
                        tag = "网格"
                        css = ""
                    }
                    temp.push({
                        id: item.orgId,
                        tag: tag,
                        css: css,
                        value: item.orgId,
                        label: item.label,
                        children: children,
                    })
                })
            }
            return temp
        },
        //条件查询
        searchlistdata(orgId) {
            this.curOrgId = orgId
            this.getPageDatas()
        },
        //获取列表数据
        async getPageDatas() {
            this.searchlist.pageNo = 1
            this.searchlist.pageSize = 20
            let params = JSON.stringify(this.searchlist)
            // console.log(params)
            var res = await request({
                url: "/admin/role/info/list",
                method: "POST",
                data: params,
            })
            if (res.code == 200) {
                if (res.content != null) {
                    this.tableData = res.content.list
                } else {
                    this.tableData = []
                }
            } else if (res.code == "10004") {
                this.$message.error(res.message)
                this.$router.push("/login")
            } else {
                console.log(res)
                this.$message({
                    message: "数据加载异常",
                    type: "error",
                })
            }
        },
        //根据组织获取已关联的角色
        async getOrgDatas() {
            this.$refs.multipleTable.clearSelection()
            // console.log(this.curOrgId)  //根据组织，查询组织关联的所有角色
            let params = JSON.stringify({ id: this.curOrgId })
            // console.log(params)
            var res = await request({
                url: "/admin/org/info/findOrgRoles",
                method: "POST",
                data: params,
            })
            // console.log(res)
            if (res.code == 200) {
                let checkedTable = []
                if (res.content && res.content.length) {
                    let roleIds = []
                    res.content.forEach((item) => {
                        if (item.id) {
                            roleIds.push(item.id)
                        }
                    })
                    this.tableData.forEach((item) => {
                        if (roleIds.includes(item.id)) {
                            this.$refs.multipleTable.toggleRowSelection(
                                item,
                                true
                            )
                            // checkedTable.push(item)
                        }
                    })
                }
            } else if (res.code == "10004") {
                this.$message.error(res.message)
                this.$router.push("/login")
            } else {
                console.log(res)
                this.$message({
                    message: "数据加载异常",
                    type: "error",
                })
            }
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$refs.multipleTable.toggleRowSelection(row)
                })
            } else {
                this.$refs.multipleTable.clearSelection()
            }
        },
        handleSelectionChange(val) {
            // multipleTable
            this.multipleSelection = val
            if (val.length > 1) {
                this.$refs.multipleTable.clearSelection()
                this.$refs.multipleTable.toggleRowSelection(val.pop())
            }

            if (val.length != 0) {
                this.selectProtocolId = val[val.length - 1].id
            }
        },
        //保存到数据库
        async saveData() {
            if (this.multipleSelection.length < 1 || this.curOrgId == "") {
                this.$message({
                    message: "请选择组织或需要分配的角色",
                    type: "error",
                })
                return
            }
            let roleIds = []
            this.multipleSelection.forEach((item) => {
                if (item.id != null) {
                    roleIds.push(item.id)
                }
            })
            let params = JSON.stringify({
                orgIds: [this.curOrgId],
                roleIds: roleIds,
            })
            console.log(params)
            var res = await request({
                url: "/admin/org/info/updateOrgRoleRelByRoleIdsAndOrgIds",
                method: "POST",
                data: params,
            })
            if (res.code == 200) {
                this.$message({
                    message: "权限分配成功",
                    type: "success",
                })
                this.$emit("func", [])
            } else if (res.code == "10004") {
                this.$message.error(res.message)
                this.$router.push("/login")
            } else {
                console.log(res)
                this.$message({
                    message: "分配失败：" + res.message,
                    type: "error",
                })
            }
        },
        async showDialogForm(roleId) {
            if (this.curOrgId == "") {
                this.$message({
                    message: "请先选择组织机构",
                    type: "error",
                })
                return
            }
            this.showViewRight = true
            this.roleId = roleId
            this.$nextTick(() => {
                //解决子组件数据无法刷新问题
                if (this.$refs.viewRoleRight !== undefined) {
                    this.$refs.viewRoleRight.id = this.curOrgId
                    this.$refs.viewRoleRight.roleId = this.roleId
                    this.$refs.viewRoleRight.getData()
                }
            })
        },
        closeDialog() {
            this.$emit("func", [])
        },
        dialogReturn(data) {
            this.showViewRight = false
        },
    },
    mounted() {
        this.getTreeDatas()
        this.getPageDatas()
    },
}
</script>
<style lang="less" scoped>
// 深度穿透样式
/deep/ .el-tree {
    float: left;
    width: 55%;
}
.roleTable {
    float: left;
    margin-left: 4.4%;
    width: 40%;
}
/deep/ .el-tree-node__content {
    border: 1px solid #ebeef5 !important;
    border-top: 0px;
    height: 40px;
    line-height: 40px;
}
/deep/ .tree-span {
    font-size: 13px;
}
</style>